import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';

import styles from './PdpSharedBuyerProtection.scss';

export const PdpSharedBuyerProtectionAuctions: FC = () => {
    return (
        <div className={styles.copy}>
            <div className={styles.title}>
                <FormattedMessage
                    id="PdpSharedBuyerProtectionAuctions.title"
                    defaultMessage="Auctions on 1stDibs"
                />
            </div>
            <div className={styles.message}>
                <FormattedMessage
                    id="PdpSharedBuyerProtectionAuctions.message"
                    defaultMessage="Our timed auctions are an opportunity to bid on extraordinary design. We do not charge a Buyer's Premium and shipping is facilitated by 1stDibs and/or the seller. Plus, all auction purchases are covered by our comprehensive Buyer Protection. <a>Learn More</a>"
                    values={{
                        a: chunks => (
                            <Link href="/info/auctions-faq/" target="_blank">
                                {chunks}
                            </Link>
                        ),
                    }}
                />
            </div>
        </div>
    );
};
